export default "__VITE_ASSET__R1uHBAbQ__"